import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { StyleSheet, View } from 'react-native'
import { router } from 'expo-router'
import { Button } from '@/src/common/components/Button'
import { Address, AutoCompleteAddress } from '@/src/common/components/AutoCompleteAddress'
import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { PointsToCashForMortgageGql } from '@/src/experiences/points-to-cash-for-mortgage/gql'
import { CashForMortgageStore } from '@/src/experiences/points-to-cash-for-mortgage/statsig/store'
import { CreateMortgageAddressMutation } from '@api/mesa/graphql'
import { useLogError } from '@/src/common/hooks/useLogError'
import { mesaColorNames } from '@/src/common/theme'

function MortgageAddress() {
  const logError = useLogError()
  const [isAddressValid, setIsAddressValid] = useState(false)
  const [mortgageAddressFormData, setMortgageAddressFormData] = useState<Address | undefined>(
    undefined,
  )
  const { setMortgageAddress } = CashForMortgageStore.useCashForMortgage()

  const [createMortgageAddress, { loading: mortgageAddressCreateLoading }] = useMutation(
    PointsToCashForMortgageGql.Mutations.CREATE_MORTGAGE_ADDRESS,
  )

  const handleContinue = () => {
    void createMortgageAddress({
      variables: {
        input: {
          address1: mortgageAddressFormData?.street1 ?? '',
          address2: mortgageAddressFormData?.street2 ?? '',
          city: mortgageAddressFormData?.city ?? '',
          state: mortgageAddressFormData?.state ?? '',
          zip: mortgageAddressFormData?.zipCode ?? '',
        },
      },
      onCompleted(data: CreateMortgageAddressMutation) {
        setMortgageAddress({
          address1: data.addMortgageAddress.address1,
          address2: data.addMortgageAddress.address2,
          city: data.addMortgageAddress.city,
          state: data.addMortgageAddress.state,
          zip: data.addMortgageAddress.zip,
          country: data.addMortgageAddress.country,
          id: data.addMortgageAddress.id,
        })
        router.push({
          pathname: '/main/points-to-cash-for-mortgage/destination-account',
        })
      },
      onError(error) {
        logError(new Error('Error creating mortgage address'), {
          error,
        })
      },
    })
  }

  return (
    <StandaloneWrapper
      screen="/main/points-to-cash-for-mortgage/mortgage-address"
      title="Turn Points into Cash for Your Mortgage"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
    >
      <View style={styles.addressContainer}>
        <AutoCompleteAddress
          mode="card-application-address"
          onChange={(address, isValid) => {
            setIsAddressValid(isValid)
            setMortgageAddressFormData(address)
          }}
          style={{ paddingTop: -888, paddingBottom: -888 }}
          showErrors={false}
        />
      </View>
      <Button
        onPress={handleContinue}
        disabled={!isAddressValid || mortgageAddressCreateLoading}
        title="Continue"
        style={{ marginBottom: 40 }}
      />
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  addressContainer: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    padding: 24,
    borderRadius: 8,
  },
})

export const MortgageAddressScreen = {
  Screen: MortgageAddress,
  Name: 'mortgage-address',
}
